export default __webpack_public_path__ + "resources/icons/d500-3752.png";